import {
  browserLocalPersistence,
  browserSessionPersistence,
  initializeAuth
} from 'firebase/auth';
import firebase from '.';

export const firebaseAuth = initializeAuth(firebase, {
  persistence: [browserLocalPersistence, browserSessionPersistence]
});

export default firebaseAuth;
